// src/Pages/Admin/ListingsPage.js
import React, { useEffect, useState, useContext } from "react";
import AdminLayout from "../../Components/admin/adminLayout";
import { AuthContext } from "../../contextStore/AuthContext";
import client from "../../api/client";

export default function ListingsPage() {
  const { token: userToken } = useContext(AuthContext) || {};
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(false);

  // prefer admin_token (admin login) then fallback to user token
  function getAuthHeaders() {
    try {
      const adminTokenRaw = localStorage.getItem("admin_token") || localStorage.getItem("adminToken");
      const adminToken = adminTokenRaw ? String(adminTokenRaw).trim() : null;
      if (adminToken && adminToken !== "null" && adminToken !== "undefined") {
        return { Authorization: `Bearer ${adminToken}` };
      }
    } catch (e) {
      // ignore localStorage errors
    }
    return userToken ? { Authorization: `Bearer ${userToken}` } : {};
  }

  useEffect(() => {
    // load on mount and whenever tokens change in localStorage (basic)
    loadListings();

    // also attach a storage listener so if admin_token is set in another tab we reload
    function onStorage(e) {
      if (e.key === "admin_token" || e.key === "token") {
        loadListings();
      }
    }
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []); // intentionally only on mount (we reload on storage events)

  async function loadListings() {
    setLoading(true);
    try {
      // canonical API path: /api/admin/listings
      const res = await client.get("/api/admin/listings", {
        headers: getAuthHeaders(),
      });

      // Accept multiple response shapes:
      // { ok: true, listings: [...] }, or { listings: [...] }, or direct array
      const data = res?.data ?? {};

      if (Array.isArray(data.listings)) {
        setListings(data.listings);
      } else if (Array.isArray(data.data)) {
        setListings(data.data);
      } else if (Array.isArray(data)) {
        setListings(data);
      } else if (data.ok && Array.isArray(data.listings)) {
        setListings(data.listings);
      } else {
        // unknown shape — try common fields or empty
        setListings(data.listings || data.results || []);
      }
    } catch (err) {
      console.error("Failed to fetch listings:", err);
      // show a user-friendly message
      alert("Error loading listings. Please login to admin or try again.");
      setListings([]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <AdminLayout>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <h2 style={{ margin: 0 }}>Manage Listings</h2>
        <div style={{ color: "#6b7280" }}>{loading ? "Loading…" : `${listings.length} listings`}</div>
      </div>

      <table border="1" cellPadding="8" style={{ background: "#fff", width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ padding: 8 }}>ID</th>
            <th style={{ padding: 8 }}>Title</th>
            <th style={{ padding: 8 }}>Seller</th>
            <th style={{ padding: 8 }}>Price</th>
            <th style={{ padding: 8 }}>Status</th>
            <th style={{ padding: 8 }}>Created At</th>
          </tr>
        </thead>
        <tbody>
          {listings.length === 0 ? (
            <tr>
              <td colSpan={6} style={{ padding: 12, textAlign: "center" }}>
                {loading ? "Loading listings…" : "No listings found"}
              </td>
            </tr>
          ) : (
            listings.map((l) => (
              <tr key={l.id}>
                <td style={{ padding: 8 }}>{l.id}</td>
                <td style={{ padding: 8 }}>{l.title || l.name || "—"}</td>
                <td style={{ padding: 8 }}>{l.seller_name || l.seller || l.sellerName || "—"}</td>
                <td style={{ padding: 8 }}>{typeof l.price !== "undefined" ? l.price : "—"}</td>
                <td style={{ padding: 8 }}>{l.status || l.state || "—"}</td>
                <td style={{ padding: 8 }}>{l.created_at ? new Date(l.created_at).toLocaleString() : "—"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </AdminLayout>
  );
}
